/*
 * Author: Dw
 * File Created: Friday, 25-05-23 11:36 am
 * Last Modified: Thursday, 25-06-05 03:45 pm, by Dw
 */

import { produce } from 'immer';
import { create } from 'zustand';

import { createStoreActions, sleep } from '@web/utils';

import type { TypeAccountManagementFee } from '../@types/marketing';
import { getAccountManagementFee } from '../services/marketing.service';
// import { getAccountManagementFee } from '../services/marketing.service';

interface MarketingStoreState {
  accountManagementFee:
    | null
    | (TypeAccountManagementFee & { isShow?: boolean });
}

interface DvaultStoreAction {
  clearAccountManagementFeeData: () => void;

  getAccountManagementFeeData: () => Promise<TypeAccountManagementFee | void | null>;
}

const defaultState: MarketingStoreState = {
  accountManagementFee: null,
};

const makingActions = createStoreActions<
  MarketingStoreState,
  DvaultStoreAction
>((set, get) => ({
  clearAccountManagementFeeData: () => {
    set(
      produce((state: MarketingStoreState) => {
        state.accountManagementFee = null;
      }),
    );
  },
  getAccountManagementFeeData: async () => {
    const res = await getAccountManagementFee();
    const { data } = res || {};
    const {
      targetAchievedReminderShown,
      consumptionReminderShown,
      needRemindRemainingConsumptionAmount,
      isValidPeriod,
      targetAchieved,
      accountFeeSwitch,
    } = data || {};

    if (data) {
      set(
        produce((state: MarketingStoreState) => {
          state.accountManagementFee = data
            ? {
                ...data,
                isShow:
                  // accountFeeSwitch is true
                  accountFeeSwitch &&
                  // step 3
                  ((targetAchievedReminderShown === 0 &&
                    targetAchieved === 1) ||
                    // 第一个和第二个必须是有效期内 因此需要 isValidPeriod
                    Boolean(
                      (consumptionReminderShown === 0 ||
                        needRemindRemainingConsumptionAmount === 1) &&
                        isValidPeriod,
                    )),
              }
            : null;
        }),
      );

      return res.data;
    }
  },
}));

export const useMarketingStore = create<
  MarketingStoreState & DvaultStoreAction
>()((set, get) => ({
  ...defaultState,
  ...makingActions(set, get),
}));
